"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Case = function Case(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "25",
    height: "25",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.4",
    d: "M19.2708 11.9792V8.33332C19.2708 8.04568 19.0376 7.81249 18.75 7.81249H15.1042V6.30633C15.1042 6.29681 15.1032 6.28755 15.1027 6.27817C15.1032 6.2688 15.1042 6.25951 15.1042 6.25002C15.1042 5.96238 14.871 5.72919 14.5833 5.72919H10.4167C10.129 5.72919 9.89582 5.96238 9.89582 6.25002V7.81252H6.24999C6.22652 7.81252 6.20361 7.8146 6.18095 7.81761C6.15155 7.82152 6.12276 7.82733 6.0951 7.83593C6.06478 7.84536 6.03581 7.85775 6.00815 7.87227C6.00604 7.87337 6.00381 7.87424 6.00173 7.87537C5.99128 7.88104 5.98133 7.88749 5.97132 7.89383C5.96718 7.89646 5.96284 7.89872 5.95879 7.90144C5.9554 7.90372 5.95233 7.90639 5.94904 7.90873C5.92511 7.92571 5.90242 7.94432 5.8817 7.96504C5.86099 7.98575 5.84241 8.00844 5.8254 8.03234C5.82302 8.03567 5.82036 8.03873 5.8181 8.04209C5.81538 8.04614 5.8131 8.05051 5.81049 8.05465C5.80413 8.06463 5.79771 8.07459 5.79203 8.08506C5.79091 8.08714 5.79004 8.08937 5.78894 8.09148C5.77441 8.11915 5.76203 8.14814 5.7526 8.17843C5.744 8.20607 5.73819 8.23489 5.73428 8.26429C5.73127 8.28691 5.72919 8.30986 5.72919 8.33332V11.9792H19.2709H19.2708ZM10.9375 6.77082H14.0625V7.81249H10.9375V6.77082Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.4",
    d: "M5.72919 13.0208V16.6666C5.72919 16.9543 5.96238 17.1875 6.25002 17.1875H18.75C18.7735 17.1875 18.7964 17.1854 18.8191 17.1824C18.8485 17.1785 18.8772 17.1727 18.9049 17.1641C18.9352 17.1546 18.9642 17.1423 18.9919 17.1277C18.994 17.1266 18.9962 17.1258 18.9983 17.1246C19.0087 17.119 19.0187 17.1125 19.0287 17.1062C19.0328 17.1035 19.0372 17.1013 19.0412 17.0986C19.0446 17.0963 19.0477 17.0936 19.051 17.0913C19.0749 17.0743 19.0976 17.0557 19.1183 17.035C19.139 17.0142 19.1576 16.9916 19.1746 16.9677C19.177 16.9643 19.1797 16.9613 19.1819 16.9579C19.1846 16.9539 19.1869 16.9495 19.1895 16.9454C19.1959 16.9354 19.2023 16.9254 19.208 16.9149C19.2091 16.9129 19.21 16.9106 19.2111 16.9085C19.2256 16.8809 19.238 16.8519 19.2474 16.8216C19.256 16.7939 19.2618 16.7651 19.2657 16.7357C19.2687 16.7131 19.2708 16.6901 19.2708 16.6667V13.0208H5.72919V13.0208Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M13.5417 14.0625H11.4583C11.1707 14.0625 10.9375 13.8293 10.9375 13.5417V11.4583C10.9375 11.1707 11.1707 10.9375 11.4583 10.9375H13.5417C13.8293 10.9375 14.0625 11.1707 14.0625 11.4583V13.5417C14.0625 13.8293 13.8293 14.0625 13.5417 14.0625ZM11.9792 13.0208H13.0208V11.9792H11.9792V13.0208Z",
    fill: props.foregroundColor
  }));
};

Case.defaultProps = {
  altText: "Case",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Case.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Case;
exports.default = _default;